import React, { useState } from "react";
import { TextField, InputLabel, Button } from "@material-ui/core";
import { useFormFields2 } from "../libs/hooksLib.js";
import LoaderButton from "./LoaderButton";
import { useToasts } from "react-toast-notifications";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";

const theme = createMuiTheme({
  palette: {
    secondary: {
      main: "#cae4db",
    },
  },
});

export default function LogIn(props) {
  const { handleLogin } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [signup, setSignup] = useState(false);
  const { addToast } = useToasts();
  const { formStyle } = props;
  const [fields, handleFieldChange] = useFormFields2({
    email: "",
    confirmEmail: "",
    password: "",
    confirmPassword: "",
  });

  function confirmInfo(fields) {
    let value =
      fields.email === fields.confirmEmail &&
      fields.password === fields.confirmPassword;
    if (value === true) {
      setSignup(false);
    } else {
      setSignup(true);
    }
    return value;
  }

  async function handleSubmit(event) {
    event.preventDefault();

    try {
      const response = await handleLogin(fields.email, fields.password);
      console.log(response);
      // we should look into why toast not firing
      addToast("Success", { appearance: "success" });
    } catch (e) {
      console.log(e);
      // check why this isn't firing
      addToast(e.message, { appearance: "error" });
    }
  }

  async function handleSubmitRegistration() {
    setIsLoading(true);
    let body = {
      profile: {
        firstName: "Test",
        lastName: "2",
        email: fields.email,
        login: fields.email,
      },
      credentials: {
        password: { value: fields.password },
        recovery_question: {
          question: "What is your password?",
          answer: "BossMove",
        },
      },
    };
    try {
      // validateForm();
      console.log("Request body ", JSON.stringify(body));
      fetch(
        `https://cors-anywhere.herokuapp.com/https://dev-534680.okta.com/api/v1/users?activate=true`,
        {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: `SSWS 00v1MkKytFweyi3O-8zvlrgquKIvTInFYU3ztkWfxX`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.errorCode === "E0000001") {
            console.log("user exists in Okta: ", data);
            data = {
              id: "kdlfjleijflajlkjlkjjljeij",
            };
          } else if (data.errorCode) {
            console.log("error at okta check: ", data);
            alert("error at okta check: ", data);
            return;
          }
          console.log("Data in okta response: ", data);
          console.log("fields at add user after okta: ", fields);
          localStorage.setItem("authenticated", true);
          localStorage.setItem("user", JSON.stringify(data));
          props.setUserInLogin(data);
          props.unlock();
        })
        .catch((err) => console.log(err));
    } catch (e) {
      alert(e.message);
      setIsLoading(false);
    }
  }

  return (
    <div style={{ marginTop: 80 }}>
      <ThemeProvider theme={theme}>
        {!signup ? (
          <div
            class="userInputLabel"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <form onSubmit={handleSubmit}>
              <h1 style={{ fontSize: 48, marginBottom: 20 }}>Welcome.</h1>
              <p style={{}}>
                Please login to your account or create an account to get
                started.{" "}
              </p>
              {/* <div style={formStyle}>
                <span>First Name</span>
                <TextField
                  id="outlined-password-input"
                  variant="outlined"
                  id="firstName"
                  type="text"
                  value={fields.firstName}
                  onChange={handleFieldChange}
                />
                <br />
              </div>

              <div style={formStyle}>
                <span>Last Name</span>
                <TextField
                  id="lastName"
                  type="text"
                  variant="outlined"
                  value={fields.lastName}
                  onChange={handleFieldChange}
                />
                <br />
              </div>
              <div style={formStyle}>
                <span>Phone Number</span>
                <TextField
                  id="phone"
                  variant="outlined"
                  type="text"
                  value={fields.phone}
                  onChange={handleFieldChange}
                />
                <br />
              </div> */}
              <div
                style={{
                  paddingTop: "50px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <InputLabel
                  htmlFor="my-input"
                  label="Address"
                  style={{ alignSelf: "start" }}
                >
                  EMAIL
                </InputLabel>
                <TextField
                  id="email"
                  variant="outlined"
                  type="email"
                  onChange={handleFieldChange}
                />
                <br />
                <InputLabel
                  htmlFor="my-input"
                  style={{ alignSelf: "start" }}
                  label="Password"
                >
                  PASSWORD
                </InputLabel>
                <TextField
                  id="password"
                  variant="outlined"
                  type="password"
                  onChange={handleFieldChange}
                />
              </div>
              <br />
              <div class="frontPageButtons">
                <LoaderButton
                  className="MuiButton-containedPrimary loginButton"
                  type="submit"
                >
                  {" "}
                  Login{" "}
                </LoaderButton>
              </div>
              <br />
              <h5
                onClick={() => setSignup(true)}
                style={{
                  marginTop: 10,
                  textDecoration: "underline",
                }}
                className="hover-pointer"
              >
                Don't have an account? Register for one here.
              </h5>
            </form>
          </div>
        ) : (
          <div
            class="userInputLabel"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div>
              <h1 style={{ fontSize: 48, marginBottom: 20 }}>
                Create Your Account
              </h1>
              <p style={{}}>
                Please provide your email and select a password to get started.
              </p>
              <div
                style={{
                  paddingTop: "50px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <InputLabel
                  htmlFor="my-input"
                  label="E-mail"
                  style={{ alignSelf: "start" }}
                >
                  EMAIL
                </InputLabel>
                <TextField
                  id="email"
                  variant="outlined"
                  type="email"
                  onChange={handleFieldChange}
                />
                <br />
                <InputLabel
                  htmlFor="my-input"
                  label="E-mail"
                  style={{ alignSelf: "start" }}
                >
                  CONFIRM EMAIL
                </InputLabel>
                <TextField
                  id="confirmEmail"
                  variant="outlined"
                  type="confirmEmail"
                  onChange={handleFieldChange}
                />
                <br />
                <InputLabel
                  htmlFor="my-input"
                  style={{ alignSelf: "start" }}
                  label="Password"
                >
                  PASSWORD
                </InputLabel>
                <TextField
                  id="password"
                  variant="outlined"
                  type="password"
                  onChange={handleFieldChange}
                />
                <br />
                <InputLabel
                  htmlFor="my-input"
                  style={{ alignSelf: "start" }}
                  label="Password"
                >
                  CONFIRM PASSWORD
                </InputLabel>
                <TextField
                  id="confirmPassword"
                  variant="outlined"
                  type="password"
                  onChange={handleFieldChange}
                />
              </div>
              <br />
              <div class="frontPageButtons">
                <LoaderButton
                  className="MuiButton-containedPrimary loginButton"
                  onClick={() => setSignup(false)}
                >
                  Cancel
                </LoaderButton>
                <LoaderButton
                  className="MuiButton-containedPrimary loginButton"
                  type="submit"
                  // disabled={confirmInfo}
                  onClick={handleSubmitRegistration}
                >
                  Next
                </LoaderButton>
              </div>
            </div>
          </div>
        )}
      </ThemeProvider>
    </div>
  );
}
